import * as React from "react";
import styles from "./Fault.module.scss";
import { getDomainDisplayName, priorityMap } from "../../utils/utils";
import DriveParameter from "../icons/DriveParameter";
import ElevatorGray from "../icons/ElevatorGray";
import GroupParameter from "../icons/GroupParameter";
import PlaceholderSymbol from "../icons/PlaceholderSymbol";
import { useTranslation } from "react-i18next";

type FaultProps = {
  fault: Api.AnyFault;
  priority: Api.FaultPriority;
  domain: Api.Domain;
};

const Fault: React.FC<FaultProps> = (props: FaultProps) => {
  const { fault, priority, domain } = props;
  const symbolColor = priorityMap[priority.enumValue].color;
  const priorityLabel = priorityMap[priority.enumValue].label;
  const priorityTitle = priority.name;
  const { t } = useTranslation();

  const faultReasonsParsed = fault.reason
    ? fault.reason.split("\n").map((item, i) => <p key={i}>{item}</p>)
    : "";
  const faultActionsParsed = fault.action
    ? fault.action.split("\n").map((item, i) => <p key={i}>{item}</p>)
    : "";

  const MapIcons = (domainGroupId: number, priorityLevel: number): any => {
    switch (domainGroupId) {
      case 2:
        return <ElevatorGray fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
      case 3:
        return <DriveParameter fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
      case 4:
        return <GroupParameter fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
      case 7:
        return <ElevatorGray fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
      default:
        return <PlaceholderSymbol fill={priorityMap[priorityLevel].color} title={priorityTitle} />;
    }
  };

  return (
    <div className={styles.Fault}>
      <div className={styles.FaultTitleDiv}>
        <div className={styles.TitleSymbolDiv}>
          {MapIcons(domain.domainGroup.id, priority.enumValue)}
        </div>
        <div className={styles.TitleDetailsDiv}>
          <h2>{fault.code}</h2>
          <div className={styles.TitleDetailsFlex}>
            <span>{getDomainDisplayName(domain) + " (" + domain.enumValue + ")"}</span>
            <span>{fault.name}</span>
          </div>
        </div>
        <div className={`${styles.TitleInfoDiv} ${priorityLabel}`} style={{ color: symbolColor }}>
          {priorityLabel}
        </div>
      </div>
      <div className={styles.FaultBodyDiv}>
        <div>
          <h2>{t("fault_possible_reason")}</h2>
          <span>{faultReasonsParsed}</span>
        </div>
        <div>
          <h2>{t("fault_preferred_actions")}</h2>
          <span>{faultActionsParsed}</span>
        </div>
      </div>
    </div>
  );
};

export default Fault;
